import { useEffect, useState } from "react";
import { Phone, ArrowUp, MessageCircle } from "lucide-react";
import { SITE } from "../lib/site";
import { useSiteSettings } from "../lib/settings";

/**
 * Floating action buttons (bottom-right):
 *  - Call button (always visible)
 *  - WhatsApp link (always visible)
 *  - Scroll-to-top (appears after 600px scroll)
 */
export const FloatingActions = () => {
  const [showTop, setShowTop] = useState(false);
  const { settings } = useSiteSettings();
  const phone = (settings?.phone || SITE.contact.phone).replace(/\s/g, "");
  const whatsapp = settings?.whatsapp || SITE.contact.whatsapp;

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3 items-end">
      <a
        href={`https://wa.me/${whatsapp}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        className="group w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-black/20 flex items-center justify-center hover:scale-110 transition-transform"
        title="Discuter sur WhatsApp"
        aria-label="WhatsApp"
      >
        <MessageCircle className="w-6 h-6" strokeWidth={1.75} />
      </a>
      <a
        href={`tel:${phone}`}
        data-testid="floating-call"
        className="group w-14 h-14 rounded-full bg-[#E60000] text-white shadow-lg shadow-black/20 flex items-center justify-center hover:scale-110 transition-transform"
        title="Appeler maintenant"
        aria-label="Appeler"
      >
        <Phone className="w-6 h-6" strokeWidth={1.75} />
      </a>
      <button
        type="button"
        data-testid="floating-scroll-top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className={`w-12 h-12 rounded-full bg-[#1A1A1A] text-white shadow-lg shadow-black/20 flex items-center justify-center hover:scale-110 transition-all ${
          showTop ? "opacity-100" : "opacity-0 pointer-events-none translate-y-2"
        }`}
        aria-label="Retour en haut"
      >
        <ArrowUp className="w-5 h-5" strokeWidth={1.75} />
      </button>
    </div>
  );
};

export default FloatingActions;
